import shopPagesData from './shop-pages.json'
import type { FixedRouteData } from '@/data/types'
import type { PageContent } from '@/lib/contentTypes'
import { imageMetadata, type ImageMetadata } from '@/lib/images'

interface ShopPagesManifest {
  routes: FixedRouteData[]
  pages: PageContent[]
  /** 英語の商品ページ(url が /en/...。gen-shop-pages.mjs が生成) */
  pagesEn?: PageContent[]
  imageMetadata: Record<string, ImageMetadata>
}

const shopPages = shopPagesData as ShopPagesManifest

Object.assign(imageMetadata, shopPages.imageMetadata)

export const shopRoutes = shopPages.routes
export const shopPageContent = shopPages.pages
export const shopPageContentEn: PageContent[] = shopPages.pagesEn ?? []
